import { Button, Input, Modal, Select } from "antd";

const Option = Select.Option;

export default function EditTag({ props }) {
  return (
    <Modal
      visible={props.editVisibility}
      title="Edit Tag"
      onOk={props.editTagging}
      onCancel={props.toggleEditVisibility}
      footer={[
        <Button key={"back"} onClick={props.toggleEditVisibility}>
          Return
        </Button>,
        <Button
          type="primary"
          key="submit"
          className="btn btn-success"
          loading={props.loading}
          onClick={props.editTagging}
        >
          Submit
        </Button>,
      ]}
    >
      <div className="p-2">
        <span>Tag Name</span>
        <Input
          value={props.name}
          onChange={(e) => props.setName(e.target.value)}
          placeholder={"Input Name"}
        />
      </div>

      <div className="p-2">
        <span>Tag Type</span>
        <Select
          showSearch
          className="w-100percent ant-input mn-150"
          size="default"
          value={props.tagType}
          disabled
          placeholder={"Select Tag Type"}
        >
          <Option value={"USER"}>USER</Option>
          <Option value={"ACCESSGROUP"}>ACCESSGROUP</Option>
          <Option value={"COURSE"}>COURSE</Option>
        </Select>
      </div>
    </Modal>
  );
}
